import { Activity } from '../../../models/activity'
import startTab from './defaults/startTab'
import musicTab from './defaults/musicTab'

export default {
    preloader: false,
    activityCurrentTab: 0,
    tabStatus: false,
    currentPaginationPage: 1,
    saving: false,
    savingForm: false,
    savingErrorMessage: "",
    warmupsOptions: [],
    stretchFlowsOptions: [],
    fieldOptions: {},
    sidebarOpened: false,
    currentActivity: Activity,
    updateActivity: Activity,
    equipmentsCategories: [],
    currentEquipment: {},
    flag_intensity: 1,
    currentDataList: {
        count: null,
        next: null,
        previous: null,
        results: []
    },
    colours: [],
    notesOpened: false,
    approvalOpened: false,
    approvalStatus: '',
    currentWarmup: {},
    currentStretchFlow: {},
    currentVideos: [],
    userList: [],
    currentActivityState: {
        startTab,
        musicTab
    },
    flags: [
        {
            id: 1,
            filename: 'flag-1'
        },
        {
            id: 2,
            filename: 'flag-2'
        },
        {
            id: 3,
            filename: 'flag-3'
        }
    ],
    render: {
        "activity": null,
        "title_card": false,
        "rendered": false,
        "uploaded": false,
        "txt_code": "",
        "file_location": "",
        "brightcove_id": "",
        "thumbnail": ""
    },
    pre_production: {
        "activity": null,
        "location": null,
        "location_details": "",
        "wardrobe_and_hair": "",
        "filming_notes": ""
    },
    post_production: {
        "activity": null,
        "filmed": false,
        "rough_cut": null,
        "review": null,
        "final_cut": null,
        "colour_grade": null,
        "timer": null,
        "file_location": "",
        "project_location": "",
        "edit_notes": ""
    },
    journeyList: [],
    journeyReport: {},
}